import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import heroMetaData from './heroMetaData.api';
import { authLogout } from '~/stores/redux/common/authSlice';
import { UNAUTHORIZED } from '~/config/constants';

export const fetchHeroMetaDataApi = createAsyncThunk('heroSaga/heroMetaData', async (navigate, { dispatch }) => {
    try {
        // dispatch(requestStarted()); //disabled this `dispatch`, else Update component of all heros will be re-rendered unnecessarily.
        const data = await heroMetaData.getAll();
        dispatch(fetchHeroMetaData(data));
        // dispatch(requestFinished());
    } catch (error) {
        if (error.message === UNAUTHORIZED) {
            dispatch(authLogout(navigate));
        }
    }
});

export const heroMetaDataSlice = createSlice({
    name: 'heroSaga/heroMetaData',
    initialState: {},
    reducers: {
        fetchHeroMetaData(_, { payload }) {
            return payload;
        },
    },
});

export const { fetchHeroMetaData } = heroMetaDataSlice.actions;
